import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const updateParamConfigSearch = createApi(`ParamConfigUpdateSlice`,"PUT");

const ParamConfigUpdateSlice = createSlice({
  name: 'ParamConfigUpdateSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updateParamConfigSearch.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateParamConfigSearch.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(updateParamConfigSearch.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default ParamConfigUpdateSlice.reducer;